module.exports = __webpack_public_path__ + "img/info-head.cfad32b1.png";